import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import NotFoundPage from './pages/NotFoundPage';
import CookieBanner from './components/CookieBanner';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import ScrollToTop from './components/ScrollToTop';
import ServicesPage from './pages/ServicesPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import CaseStudyDetailPage from './pages/CaseStudyDetailPage';
import './index.css'; // Ensure global styles are imported

const App: React.FC = () => {
  useEffect(() => {
    // Prevent right-click context menu on images
    const contextMenuHandler = (e: MouseEvent) => {
      if ((e.target as HTMLElement).tagName === 'IMG') {
        e.preventDefault();
      }
    };
    
    document.addEventListener('contextmenu', contextMenuHandler);
    
    return () => {
      document.removeEventListener('contextmenu', contextMenuHandler);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <CookieBanner />
      <Navbar />
      <div className="main-content-area"> {/* Optional wrapper if needed */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} /> 
          {/* Add Case Study Routes */}
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:id" element={<CaseStudyDetailPage />} /> {/* Dynamic route for details */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default App;